import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
 import jwtDecode from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { baseUrl } from 'src/app/Data/service/global.service';
import { LoginOtpRequestEndPoint, LoginOtpVerifyEndPoint, TrustedDevicesEndPoint, ActiveSessionsEndPoint, SessionLocationEndPoint } from 'src/app/Data/service/global.service';
import { PushDeviceService } from 'src/app/shared/services/push-device.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public  isLogin:BehaviorSubject<any> = new BehaviorSubject(true);

  /** عند تسجيل الدخول بـ OTP: يُملأ بعد نجاح الخطوة 1 ويُستخدم في شاشة إدخال الرمز */
  loginOtpContext: { phone_number: string; userId?: number } | null = null;

  /** Prevents re-entrant endSession when disable API returns 401. */
  private endingSession = false;

  constructor(
    private _HttpClient: HttpClient,
    private Router: Router,
    private injector: Injector,
  ) 
  {
    if(localStorage.getItem('token')!=null)
    {
       this.saveCurrentUser();
    }
    this.isLogin.next(localStorage.getItem('token'))
 };
//   Bearer
currentUser = new BehaviorSubject(null) ;

saveCurrentUser()
{
  let token:any = localStorage.getItem('token');
  
  this.currentUser.next(jwtDecode(token));

};


  Register(endPoint : string ,model: any ): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + endPoint, model )
  };

  Login(endPoint : string ,model: any ): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + endPoint, model )
  };

  /** الخطوة 1: طلب OTP بعد التحقق من الهاتف والباسورد */
  loginOtpRequest(model: { phone_number: string; password: string }): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + LoginOtpRequestEndPoint.POST, model);
  }

  /** الخطوة 2: التحقق من OTP وإكمال تسجيل الدخول */
  loginOtpVerify(model: { phone_number: string; otp: number }): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + LoginOtpVerifyEndPoint.POST, model);
  }

  /**
   * Wipes all session data from localStorage and sessionStorage, preserving only
   * non-sensitive user-preference keys (language, theme, device-id).
   * Resets all auth BehaviorSubjects so the app reflects the logged-out state immediately.
   */
  clearSession(): void {
    const curentLang   = localStorage.getItem('curentLang');
    const layoutVersion = localStorage.getItem('layout_version');
    const deviceId     = localStorage.getItem('device_id');

    localStorage.clear();
    sessionStorage.clear();

    if (curentLang)    localStorage.setItem('curentLang',    curentLang);
    if (layoutVersion) localStorage.setItem('layout_version', layoutVersion);
    if (deviceId)      localStorage.setItem('device_id',     deviceId);

    this.currentUser.next(null);
    this.isLogin.next(false);
  }

  /**
   * Tear down auth session and stop push delivery for this device.
   * Push disable runs before tokens are cleared so the API call stays authenticated.
   * PushDeviceService is resolved lazily to avoid AuthService ↔ HttpInterceptor circular DI.
   */
  async endSession(options?: { redirectTo?: string; useLocation?: boolean }): Promise<void> {
    if (this.endingSession) {
      this.clearSession();
      this.navigateAfterEndSession(options);
      return;
    }

    this.endingSession = true;
    try {
      if (localStorage.getItem('token')) {
        const pushDevice = this.injector.get(PushDeviceService);
        await pushDevice.disableOnSignOut();
      }
    } catch {
      /* best-effort — session must still clear */
    } finally {
      this.endingSession = false;
    }

    this.clearSession();
    this.navigateAfterEndSession(options);
  }

  private navigateAfterEndSession(options?: { redirectTo?: string; useLocation?: boolean }): void {
    const redirectTo = options?.redirectTo;
    if (!redirectTo) {
      return;
    }
    if (options?.useLocation) {
      window.location.href = redirectTo;
      return;
    }
    void this.Router.navigateByUrl(redirectTo);
  }

  logout(): void {
    void this.endSession({ redirectTo: '/login' });
  }

  Otp(endPoint : string ,model: any ): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + endPoint, model )
  };

  resendOtp(endPoint : string ,model: any ): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + endPoint, model )
  };

  ForgotPassword(endPoint : string ,model: any ): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + endPoint, model )
  };

  /**
   * @description Validates auto-login token securely with the backend
   * @param token - The auto-login token to validate
   * @returns Observable with authentication response
   */
  validateAutoLoginToken(token: string): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + 'auth/validate-auto-login', { token });
  }

  /** GET trusted devices list */
  getTrustedDevices(): Observable<any> {
    return this._HttpClient.get<any>(baseUrl + TrustedDevicesEndPoint.GET);
  }

  /** POST mark current session as trusted */
  markCurrentDeviceTrusted(): Observable<any> {
    return this._HttpClient.post<any>(baseUrl + TrustedDevicesEndPoint.POST_CURRENT, {});
  }

  /** DELETE revoke trusted status for a device by loginId */
  revokeTrustedDevice(loginId: number): Observable<any> {
    return this._HttpClient.delete<any>(baseUrl + 'auth/trusted-devices/' + loginId);
  }

  /** GET all active sessions (logged-in devices) for current user */
  getActiveSessions(): Observable<any> {
    return this._HttpClient.get<any>(baseUrl + ActiveSessionsEndPoint);
  }

  /** DELETE terminate a specific session by loginId (force log out that device) */
  terminateSession(loginId: number): Observable<any> {
    return this._HttpClient.delete<any>(baseUrl + 'auth/session/' + loginId);
  }

  /**
   * Use the browser's Geolocation API (GPS on mobile, WiFi on desktop) to get the user's
   * exact coordinates, then reverse-geocode them to a human-readable city + country via
   * Nominatim (OpenStreetMap). Returns null silently if the user denies permission or any
   * error occurs — so the IP-based location stored at login time is kept as the fallback.
   */
  async getBrowserLocation(): Promise<{ city: string; country: string } | null> {
    return new Promise((resolve) => {
      if (typeof navigator === 'undefined' || !navigator.geolocation) {
        resolve(null);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&accept-language=en`,
              {
                headers: {
                  'User-Agent': 'THInvoices/1.0 (thinvoices.com)',
                  'Accept': 'application/json',
                },
              },
            );
            const data = await response.json();
            const address = data?.address || {};
            const city = (
              address.city ||
              address.town ||
              address.village ||
              address.municipality ||
              address.county ||
              ''
            ).trim();
            const country = (address.country || '').trim();
            resolve({ city, country });
          } catch {
            resolve(null);
          }
        },
        () => resolve(null), // permission denied or position unavailable
        { timeout: 10000, maximumAge: 300000 }, // 10s timeout, 5-min cache
      );
    });
  }

  /** PATCH current session location with accurate browser geolocation data */
  updateSessionLocation(city: string, country: string): Observable<any> {
    return this._HttpClient.patch<any>(baseUrl + SessionLocationEndPoint, { city, country });
  }
}
